<router-outlet></router-outlet>
<dac-footer></dac-footer>
<app-login-dialog [fixedBottom]="false"></app-login-dialog>


// WEBPACK FOOTER //
// ./src/app/app.component.html